import { Component, OnInit, NgZone, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'
import { MessagingService } from 'src/app/services/api/messaging.service';
import { DeviceService } from 'src/app/services/api/device.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventsService } from 'src/app/services/api/events.service';
import { DeliveriesService } from '../../services/api/deliveries.service';
import * as _ from 'lodash';
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

export const ROUTES: RouteInfo[] = [
  // { path: '/dashboard', title: 'Dashboard',  icon: 'ni-tv-2 text-primary', class: '' },
  { path: '/jobrequest', title: 'Book a delivery', icon: '../../../../assets/icon/home/book.svg', class: '' },
  { path: '/transactions', title: 'Transactions', icon: '../../../../assets/icon/home/transaction.svg', class: '' },
  { path: '/notification', title: 'Notifications & Chats', icon: '../../../../assets/icon/home/notification.svg', class: '' },
  { path: '/history', title: 'Transactions History', icon: '../../../../assets/icon/home/history.svg', class: '' },
  { path: '/account', title: 'Account', icon: '../../../../assets/icon/home/profile.svg', class: '' },
  { path: '/services', title: 'Services', icon: '../../../../assets/icon/home/services.svg', class: '' },
  // { path: '/https://www.youtube.com/playlist?list=PLqefIo0v_YB7KemtiO7vcS9W22zdaEgMM', title: 'How to book?', icon: '../../../../assets/icon/home/youtube.svg', class: '' }
  // { path: '/icons', title: 'Icon', icon: '../../../../assets/icon/home/profile.svg', class: '' },
  // { path: '/tables', title: 'More',  icon:'ni-bullet-list-67 text-red', class: '' },
];
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {



  public menuItems: any[];
  public isCollapsed = true;
  isCorporate: boolean = false
  appVersion: any
  countsNotif: number = 0
  inprogCount: number = 0
  pendingCount: number = 0
  filter: any = {};
  isVisible: boolean = true
  public innerWidth: any;

  constructor(private router: Router,
    private messagingService: MessagingService,
    private devicesrvc: DeviceService,
    private spinner: NgxSpinnerService,
    private ngzone: NgZone,
    private cd: ChangeDetectorRef,
    private events: EventsService,
    private deliveriessrvc: DeliveriesService,) {
    // 

    this.events.getObservable().subscribe((data) => {
      // console.log("Data received:", data);
      if (data.notification) {
        this.notifCount()
      }

      if(data.count){
        this.getCount()
      }

      if(data.isCorporate){
        console.log("isCorporate", data.isCorporate.isCorporate)
        this.isCorporate = data.isCorporate.isCorporate
      }
    })
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
    this.cd.detectChanges()
    this.ngzone.run(() => {
      setTimeout(() => {
        if (localStorage.getItem("isCorporate")) {
          let corporate = JSON.parse(localStorage.getItem("isCorporate"))
          // console.log("corporate", corporate)
          this.isCorporate = corporate
        }
        // console.log("this.isCorporate", this.isCorporate)
      }, 3000)
    })
    this.appState()
    this.getCount()
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.innerWidth = window.innerWidth;
  }

  appState() {
    if(localStorage.getItem("AppVersion")){
      let versionIs = JSON.parse(localStorage.getItem("AppVersion"))
      this.appVersion = versionIs.version
      this.checkInitCount()
    }else{
      setTimeout(() => {
        let versionIs = JSON.parse(localStorage.getItem("AppVersion"))
        this.appVersion = versionIs.version
        this.checkInitCount()
      }, 1000)
    }
  }

  logout() {
    Swal.fire({
      text: "Hi, are you sure you want to logout?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText:'Close',
      customClass: 'swal-small',
      width: "20rem"
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log('Clicked Yes');
        this.spinner.show()
        this.devicesrvc.remove()
          .subscribe(async removeresp => {
            // console.log("remove token", removeresp)
            localStorage.removeItem("authToken")
            localStorage.removeItem("USER_DATA")
            localStorage.removeItem("USER_INFO")
            localStorage.removeItem("RememberMe")
            localStorage.removeItem("packagestransactionStatus")
            localStorage.removeItem("lastPage")
            localStorage.removeItem("isAlreadyLoaded")
            localStorage.removeItem("isCorporate")
            await this.recreateToken()
          }, async err => {
            // console.log("err", err)
            localStorage.removeItem("authToken")
            localStorage.removeItem("USER_DATA")
            localStorage.removeItem("USER_INFO")
            localStorage.removeItem("RememberMe")
            localStorage.removeItem("packagestransactionStatus")
            localStorage.removeItem("lastPage")
            localStorage.removeItem("isAlreadyLoaded")
            localStorage.removeItem("isCorporate")
            await this.recreateToken()
          })
      }
    })
  }

  recreateToken() {
    this.messagingService.removeToken()
      .then(async response => {
        if (response) {
          this.messagingService.renewedToken()
            .then(async resp => {
              this.spinner.hide()
              // console.log("renewedToken", resp)
              this.router.navigate(["/login"]);
              // console.log("proceed to login")
            })
        }
      })
  }

  checkInitCount() {
    if (localStorage.getItem("countsNotif")) {
      let getCount = Number(JSON.parse(localStorage.getItem("countsNotif")))
      this.countsNotif = getCount
    }
  }

  notifCount() {
    if (localStorage.getItem("countsNotif")) {
      let getCount = Number(JSON.parse(localStorage.getItem("countsNotif")))
      this.countsNotif = getCount + 1
      localStorage.setItem("countsNotif", JSON.stringify(this.countsNotif))
    } else {
      this.countsNotif = 1
      localStorage.setItem("countsNotif", JSON.stringify(this.countsNotif))
    }
    // console.log("this.countsNotif", this.countsNotif)
  }

  updateNotif(item) {
    // console.log("updateNotif", item)
    if (item.path === "/notification") {
      localStorage.setItem("countsNotif", "0")
      this.countsNotif = 0
    }
  }

  launchAppOnAndroidDevice() {

//     HOST: ionicdeeplink.cargaph.com
// SCHEME: cargashipper
// package: carga.staging.io

    const url = "intent://ionicdeeplink.cargaph.com/#Intent;scheme=cargashipper;package=carga.staging.io;end";
    window.location.replace(url);
  }

  openServices(){
    
  }

  async getCount() {
    this.filter.deliveryStatus = "inProgress";
    this.deliveriessrvc.getAll(this.filter, localStorage.getItem('authToken'))
      .then(async (data) => {
        let packages = data["data"] || [];
        let newpackages = [];
        for (let i = 0; i < packages.length; i++) {

          let newpackageStatus = [];
          let currentstatus = 0;

          if (packages[i].deliveryStatus != "inProgress.driverAccepted") {
            if (
              packages[i].deliveryStatus == "inProgress.driverAccepted" &&
              packages[i].transactionAmountInfo.status == undefined
            ) {
              currentstatus = 1;
            }

            if (
              packages[i].deliveryStatus == "inProgress.driverAccepted" &&
              packages[i].transactionAmountInfo.status == "success"
            ) {
              currentstatus = 2;
            }

            if (packages[i].deliveryStatus == "inProgress.driverForPickup") {
              currentstatus = 3;
            }

            if (packages[i].deliveryStatus == "inProgress.driverLoading") {
              currentstatus = 4;
            }

            if (packages[i].deliveryStatus == "inProgress.driverEnRoute") {
              currentstatus = 5;
            }

            if (packages[i].deliveryStatus == "inProgress.driverForDropoff") {
              currentstatus = 6;
            }

            packages[i].packageStatus = await newpackageStatus;
            newpackages.push(packages[i]);
          }
        }
        this.inprogCount = _.size(newpackages) <= 0 ? 0 : _.size(newpackages)
        // console.log("inprogCount", this.inprogCount)
      })

    let initialPackages = [];
    this.deliveriessrvc.getAll("", localStorage.getItem('authToken'))
      .then(async (data) => {
        let packages = data["data"] || [];
        // Uncomment Me when Debug mode is done
        let sortedPackages = packages.sort((a, b) => {
          return b.dateUpdated - a.dateUpdated;
        });
        sortedPackages.forEach((element) => {
          if (
            element.deliveryStatus == "open" ||
            element.deliveryStatus == "inProgress.driverAccepted" ||
            element.deliveryStatus == "pending.ownerAccepted"
          ) {
            let checkifexist = initialPackages.findIndex(
              (item) => item.deliveryId === element.deliveryId
            );
            if (checkifexist < 0) {
              initialPackages.push(element);
            }
          }
        });
        this.pendingCount = _.size(initialPackages) <= 0 ? 0 : _.size(initialPackages)
        // console.log("pendingCount", this.pendingCount)
      })
  }

  openMenu(){
    this.isVisible=!this.isVisible
    this.events.publishData({isMinimize: this.isVisible})
    console.log("isVisible", this.isVisible)
  }

}
